import * as React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import * as Hooks from 'hooks'
import * as Tabs from 'components/tabs'
import Fieldset from '../../components/Fieldset'
import Renderer from '../../components/Renderer'
import * as Strings from '@avcan/utils/string'
import * as Utils from '../../../utils'
import { ObservationTypes, ObservationColors } from '@avcan/constants/products/min'
import styles from './styles.module.css'

export default function ObservationSet({ props }) {
    const [{ width }, ref] = Hooks.useClientRect(Hooks.getWindowSize)
    const [active, setActive] = React.useState()
    const context = useFormContext()
    const { errors } = context.formState

    React.useEffect(() => {
        const keys = Object.keys(errors)

        if (keys.length === 0) {
            return
        }

        if (keys.some(isObservationKey)) {
            const key = keys.find(isObservationKey)
            const type = Strings.toPath(key)[1]

            if (ObservationTypes.has(type)) {
                const index = Array.from(ObservationTypes).indexOf(type)

                setActive(index)
            }
        }

        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        })
    }, [errors])

    return (
        <div ref={ref}>
            <Tabs.Container eager activeTab={active} onTabChange={setActive}>
                <Tabs.HeaderSet stacked={width < 400}>
                    {props.items.map(item => {
                        const { name, legend } = item

                        return (
                            <Header key={name} name={name}>
                                {legend}
                            </Header>
                        )
                    })}
                </Tabs.HeaderSet>
                <Tabs.PanelSet>
                    {props.items.map((item, index) => (
                        <Panel key={item.name} index={index} item={item} />
                    ))}
                </Tabs.PanelSet>
            </Tabs.Container>
        </div>
    )
}

function Header({ name, children, ...props }) {
    const [type] = Strings.toPath(name).reverse()
    const report = useWatch({ name })
    const color = Utils.sanitize(report, null) ? ObservationColors.get(type) : null

    return (
        <Tabs.ColoredHeader {...props} color={color} arrow>
            {children}
        </Tabs.ColoredHeader>
    )
}

function Panel({ item, index }) {
    return (
        <Tabs.Panel index={index}>
            <Fieldset {...item} legend={null} className={styles.Fieldset}>
                <Renderer {...item} />
            </Fieldset>
        </Tabs.Panel>
    )
}

// Utils
function isObservationKey(key) {
    return key.startsWith('observations')
}
